import React from "react";
const __pages_import_0__ = React.lazy(() => import("/src/pages/Buttons.jsx"));
const __pages_import_1__ = React.lazy(() => import("/src/pages/Typography.jsx"));
const __pages_import_2__ = React.lazy(() => import("/src/pages/default.jsx"));

const routes = [{"caseSensitive":false,"path":"Buttons","element":React.createElement(__pages_import_0__)},{"caseSensitive":false,"path":"Typography","element":React.createElement(__pages_import_1__)},{"caseSensitive":false,"path":"default","element":React.createElement(__pages_import_2__)}];

export default routes;